import { Radio, Typography } from 'antd';
import type { Localization } from '@entities/assistant';

const { Text } = Typography;

interface Option {
  value: Localization;
  title: string;
  description: string;
}

/**
 * Подписи рассчитаны на пользователя-владельца малого/среднего бизнеса,
 * не на разработчика. Технические детали (имя модели, провайдер) убраны
 * в пользу того, что юзеру реально нужно понять: качество vs страна-провайдер.
 */
const OPTIONS: Option[] = [
  {
    value: 'NONE',
    title: 'Международные сервисы',
    description: 'OpenAI GPT-4o-mini. ',
  },
  {
    value: 'PARTIAL',
    title: 'Российские сервисы, кроме картинок',
    description: 'YandexGPT для текста. Картинки в документах обрабатываются OpenAI Vision.',
  },
  {
    value: 'FULL',
    title: 'Только российские сервисы',
    description: 'YandexGPT, без обработки картинок. Все данные обрабатываются в РФ.',
  },
];

interface Props {
  value?: Localization;
  onChange?: (value: Localization) => void;
}

export function LocalizationRadio({ value, onChange }: Props) {
  return (
    <Radio.Group
      value={value}
      onChange={(e) => onChange?.(e.target.value as Localization)}
      style={{ display: 'flex', flexDirection: 'column', gap: 10, width: '100%' }}
    >
      {OPTIONS.map((opt) => {
        const selected = value === opt.value;
        return (
          <Radio
            key={opt.value}
            value={opt.value}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              padding: '12px 14px',
              margin: 0,
              border: `1px solid ${selected ? '#1F2937' : '#E5E7EB'}`,
              borderRadius: 8,
              background: selected ? '#F9FAFB' : '#FFFFFF',
              transition: 'border-color 0.15s, background 0.15s',
            }}
          >
            <div style={{ marginLeft: 4 }}>
              <div style={{ fontWeight: 500, color: '#1A1A1A', marginBottom: 2 }}>
                {opt.title}
              </div>
              <Text type="secondary" style={{ fontSize: 12, lineHeight: 1.45 }}>
                {opt.description}
              </Text>
            </div>
          </Radio>
        );
      })}
    </Radio.Group>
  );
}
